'use client';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import React, {
  createContext,
  useLayoutEffect,
  useMemo,
  useState,
} from 'react';

export const GSAPContext = createContext({
  gsap: null,
  ScrollTrigger: null,
});

export const GSAPProvider = ({ children }) => {
  const [isReady, setIsReady] = useState(false);

  useLayoutEffect(() => {
    if (typeof window !== 'undefined') {
      try {
        gsap.registerPlugin(ScrollTrigger);
        setIsReady(true);
        console.log('GSAP and ScrollTrigger initialized successfully');
      } catch (error) {
        console.error('Failed to initialize GSAP and ScrollTrigger:', error);
      }
    }
  }, []);

  const contextValue = useMemo(
    () => ({
      gsap: isReady ? gsap : null,
      ScrollTrigger: isReady ? ScrollTrigger : null,
    }),
    [isReady],
  );

  return (
    <GSAPContext.Provider value={contextValue}>
      {isReady ? children : null}
    </GSAPContext.Provider>
  );
};
